import { z } from 'zod';
import { apiRequest } from '../../../shared/api/client';
import { createMutation } from '../../../shared/api/mutation';
import { meQueryKey } from '../../../shared/auth/auth.svelte';
import { useQueryClient } from '@tanstack/svelte-query';

const CompleteSchema = z.object({ onboardedAt: z.string() });

/**
 * Marks the caller's membership as welcomed; the tour never opens by itself again. Finishing and
 * skipping both end here. `/v1/me` is refetched so the gate sees the new `onboardedAt`.
 */
export function useCompleteWelcome(orgId: () => string) {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: () => apiRequest('/v1/orgs/current/onboarding/complete', { method: 'POST', orgId: orgId(), schema: CompleteSchema }),
    onSuccess: () => qc.invalidateQueries({ queryKey: meQueryKey }),
  }));
}
